import Report from "./Report";

export default class Workspace {
    constructor(obj){
        obj = obj || {};
        this.workspaceId = obj.workspaceId;
        this.workspaceName = obj.workspaceName;
        this.reports = obj.reports && obj.reports.map(r => new Report(r));
    }
}